import React from 'react';
import { Avatar } from 'components/avatar/avatar';

import { Heading } from 'components/heading/heading';
import { Button } from 'components/button/button';
import { appUrl } from 'constants/baseUrl';

import styles from './profileCard.module.scss';

export const ProfileCard = ({
  firstHeading,
  secondHeading,
  profileUrl,
  thirdHeading,
  label,
  avatar,
  children,
  slug,
}) => {
  return (
    <div className={styles.profile}>
      <Avatar {...avatar} className={styles.avatar} size={100} />
      <br />
      <br />
      <Heading size="medium" className={styles.firstHeading}>
        {firstHeading}
        <small>{label}</small>
      </Heading>
      <Button
        style={{ width: '170px', margin: 'auto' }}
        // onClick={() => window.open(profileUrl, '_blank')}
        size="small"
        submit
      >
        <a
          style={{ color: 'white', textDecoration: 'none' }}
          href={`${appUrl}/profile/${slug}`}
          target={'_blank'}
        >
          Visit Holedo Profile
        </a>
      </Button>
      <p className={styles.secondHeading}>{secondHeading}</p>
      <p className={styles.thirdHeading}>{thirdHeading}</p>
      <div className={styles.profileActions}>{children}</div>
    </div>
  );
};
